// pages/Login.js
import React from 'react';
import { Form, Input, Button, Typography, Card, message } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../css/login.css';
import logo from '../../assets/images/login2.jpeg';

const { Title, Text } = Typography;

const Login = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const res = await axios.post(`${BASE_URL}/api/user/login`, values);

      // Simpan token dan user
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));

      // message.success('Login berhasil!');
      navigate('/dashboard'); // langsung ke profile
    } catch (error) {
      console.error('Login error:', error);
      message.error('Login gagal, cek username/password.');
    }
  };

  return (
    <div className="login-wrapper">
      <Card className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />
        <Title level={3} className="login-title">Admin Bolde Id</Title>
        <Text type="secondary">Please login to your account</Text>

        <Form layout="vertical" onFinish={onFinish} style={{ marginTop: 24 }}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input placeholder="Enter your username" size="large" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Enter your password" size="large" />
          </Form.Item>

          <Button type="primary" htmlType="submit" size="large" className="login-button">
            Login
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
